(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            if (this._rendered) return;
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            if (this._clickHandler) return;
            if (this.belongsToForm) return;
            this._clickHandler = this._onClick.bind(this);
            this.$button.addEventListener('click', this._clickHandler);
        }
 
        _onClick(e) {
            // ALWAYS stop default to avoid form double submit
            e.preventDefault();
            e.stopPropagation();
            this.loading = true;
            this.addToCart(this.cartItem);
        }

        addToCart(items) {
            this.publish('cart:add', {
                 items: items ?? this.cartItem  
            });
        }

        _cartUpdateHandler() {
            console.log('cartUpdateHandler - resetting loading');
            setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        set loading(state) {
    console.log('loading set to', state, 'button connected:', this.$button?.isConnected);
    this.$button.classList.toggle(CN_LOADING, state);
}

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
        const quantity = this.getAttribute('quantity') || 1;
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: +quantity
            }]
        }
            
        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();